
export default {
  inheritAttrs: false,
  props: {
    country: {
      type: Object,
      default: null
    },
    label: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    label: {
      fontSize: 'sm',
      fontWeight: 'light',
      textColor: 'black'
    }
  },
  computed: {
    labelText() {
      const name = this.country.name
      const label = this.$t('madeIn')

      return `${label} ${name}`
    }
  }
}
